module.exports = __webpack_public_path__ + "static/media/AMX-Bold.11587919.woff2";